import React from 'react';
import { MdStars } from 'react-icons/md';
import { Tooltip, Whisper } from 'rsuite';
import { TableBadge } from '../../TableBadge';
import { BaseCell } from '../BaseCell';
import { BaseCellProps } from '../BaseCell/BaseCell';
import styles from './ProductFamilyClusterCell.module.scss';

const { MainContainer, SubContainer } = BaseCell;

type ProductFamilyClusterCellProps = BaseCellProps & {
  rowData: {
    productId: string;
    description: string;
    isProductMaster: boolean;
  };
};

const ProductFamilyClusterCell = ({ rowData, ...props }: ProductFamilyClusterCellProps) => {
  const { description, productId, isProductMaster } = rowData;
  return (
    <BaseCell {...props}>
      <MainContainer>
        <span className={styles.product_id}>{productId}</span>

        {isProductMaster && (
          <TableBadge skin="blue" style={{ marginLeft: '5px' }}>
            <MdStars />
            PAI
          </TableBadge>
        )}
      </MainContainer>
      <SubContainer>
        <Whisper delayShow={0.2} trigger="hover" placement="right" speaker={<Tooltip>{description}</Tooltip>}>
          <p className={styles.description}>{description}</p>
        </Whisper>
      </SubContainer>
    </BaseCell>
  );
};

export default ProductFamilyClusterCell;
